export default [
  {
    path: "/ai-companies",
    name: "ai-companies",
    component: () => import("@/modules/ai-companies/AiCompanies.vue"),
    children: [
      {
        path: "list",
        name: "list-ai-companies",
        component: () =>
          import("@/modules/ai-companies/pages/AiCompaniesList.vue"),
        meta: { permissions: ["ai-companies-show"] }
      },
      {
        path: "add",
        name: "add-ai-companies",
        component: () =>
          import("@/modules/ai-companies/pages/AiCompaniesAdd.vue"),
        meta: { permissions: ["ai-companies-create"] }
      }
    ]
  }
];
